import { useState } from 'react';
import { Message } from '../types/chat';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { sendFeedback } from '../services/feedback-service';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '../../../state/store/chat/use-chat-store';
import { useTheme } from '../../../components/core/theme-provider';
import { useConfig } from 'hooks/use-config';

type FeedbackProps = {
  message: Message;
};

export function Feedback({ message }: FeedbackProps) {
  const conversationId = useChatStore((state) => state.activeConversationId);
  const [liked, setLiked] = useState<boolean | undefined>(message.feedback);
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { configurationSettings } = useConfig();

  const handleThumbsClick = (messageId: string, isLiked: boolean) => {
    setLiked(isLiked);
    if (!conversationId) return;
    sendFeedback(
      {
        conversation_id: conversationId,
        msg_id: messageId,
        feedback: isLiked,
      },
      configurationSettings
    );
  };

  return (
    <div className="flex gap-2 justify-start">
      <button
        title={t('GOOD_RESPONSE')}
        className="h-8 pl-4 hover:bg-muted"
        onClick={() => handleThumbsClick(message.id, true)}
      >
        <ThumbsUp
          size={16}
          className={
            liked !== undefined && liked
              ? `${theme === 'light' ? 'fill-black' : 'fill-gray-100'}`
              : 'fill-none'
          }
        />
      </button>

      <button
        title={t('BAD_RESPONSE')}
        className="h-8 pl-4 hover:bg-muted"
        onClick={() => handleThumbsClick(message.id, false)}
      >
        <ThumbsDown
          size={16}
          className={
            liked !== undefined && !liked
              ? `${theme === 'light' ? 'fill-black' : 'fill-gray-100'}`
              : 'fill-none'
          }
        />
      </button>
    </div>
  );
}
